import React from 'react';
import LazyLoad from 'react-lazyload';

const AppList = ({ app, addApp }) => {

  return(
    <div className="app" id={app.id}>
      <div className="empty">
        <LazyLoad height={100} offset={500}>
          <img src={app.icon} alt={app.title} />
        </LazyLoad>
      </div>
      <LazyLoad height={75} offset={500}>
        <div className="content">
          <h5 className="title">
            {app.title}
          </h5>
          <p className="tagline">
            {app.tagline}
          </p>
          {/*<p>
            <a className="site-link" href={app.url} target="_blank" rel="nofollow">
            Visit Site
            </a>
          </p>*/}
        </div>
        
      </LazyLoad>
      <div className="actions">
        <button className="add" onClick={() => addApp(app)}>
          <i className="fa fa-angle-right"></i>
          <i className="fa fa-angle-left"></i>
        </button>
      </div>
    </div>
  );
}

export default AppList;


// WEBPACK FOOTER //
// ./src/components/AppList.js